import React, { useState } from 'react'
import Grid from '@mui/material/Grid'
import {Text} from '../../../assets/Text'
import { ImageButton, Button } from '../../../assets/Buttons'
import * as Icons from '../../../assets/Icons'
import CustomTheme from '../../../assets/CustomTheme'
import matchConfig from '../../../config/matchConfig'
import AuthenticationHelper from '../../../helpers/AuthenticationHelper'
import ChatSocketHelper from '../../../helpers/ChatSocketHelper'
import ChatSystemHelper from '../../../helpers/ChatSystemHelper'
import ChatInfoStore from '../../../helpers/ChatInfoStore'

const Wrapper = (props) => (<CustomTheme>
    <Grid container direction={"column"} justifyContent={"center"}>
        <Grid container direction={"column"} justifyContent={"center"} alignItems={"center"}
            sx={{
                bgcolor: 'background.light',
                m:0,
                mt: 'auto',
                mb: 'auto',
                py: {
                    xs: 1,
                    sm: 2,
                    md: 2
                },
                height: {
                    xs: '64px',
                    sm: '80px',
                    md: '80px',
                },
                boxShadow: 3
            }}
        >
            <Grid container direction={"row"} justifyContent={{
                xs: 'flex-start',
                sm: 'center'
            }} alignItems={"center"} spacing={{
                xs: 1,
                sm: 2
            }}
                sx={{
                    pl: {
                        xs: 1,
                        sm: 0
                    }
                }}
            >
                <Grid item
                    sx={{
                        width: {
                            md: '48px',
                            sm: '48px',
                            xs: '48px'
                        },
                        p: 0
                    }}
                >
                    <Icons.Logo style={{ width: "100%" }} />
                </Grid>
                <Grid item>
                    <Text >Peer Social Support</Text>
                </Grid>


                <Grid item 
                    sx={{
                        position: 'absolute',
                        right: {
                            xs: '8px',
                            sm: '16px',
                            md: '32px'
                        }
                    }}
                ><Button onClick={() => {
                    props.switchPage(matchConfig.pages.login)
                    props.matchLogout()
                    AuthenticationHelper.resetToken()
                    //reset all the chat parameters
                    ChatSystemHelper.resetChatToken()
                    // ChatInfoStore.chatRoomInfo=null
                    ChatInfoStore.resetChatInfo()
                    ChatSocketHelper.logout()
                }}>{props.lang.logout}</Button></Grid>

            </Grid>
        </Grid>
        {props.children}
    </Grid>
    </CustomTheme>
)

export default Wrapper